import { setSelected } from '../../../State/selected'

export default (keys) => (dispatch) => {

  dispatch(setSelected(keys.filter(key => key.split('|')[0] !== 'timesheet-posting')))

}
